import { useOrganization } from "../../contexts/OrganizationContext";
import { useAuth } from "../../contexts/AuthContext";
/** Requests pause while scope is resolving. Every query includes this owner identity. */
export function useAnalyticsScope() {
  const { user } = useAuth();
  const { currentOrganization, loading, error, refreshOrganizations } =
    useOrganization();
  const role = (currentOrganization as { user_role?: string } | null)
    ?.user_role;
  return {
    scope: {
      userId: user?.id ?? "",
      organizationId: currentOrganization?.id ?? null,
    },
    ready: !!user && !loading && !error,
    error,
    retry: refreshOrganizations,
    canManage: !currentOrganization || role === "owner" || role === "admin",
  };
}
